/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {IFruitsInitData, IFruitsServerData} from "./data/IFruitsServerData";

export class FruitsServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseReels(rawData:IFruitsServerData):string[][] {
        let result:string[][] = [];
        rawData.reels.forEach((reel:string[], reelId:number) => {
            reel.forEach((symbol:string, symId:number) => {
                // when restore in bonus game intro, should parse the reels as normal game but the gameMode is already bonus, so use isBonusTriggeredThisSpin to exclude it.
                if(rawData.mode === FruitsGameMode.BONUS_GAME && !rawData.isBonusTriggeredThisSpin) {
                    if(reelId > 3 && symId === 0) {
                        return;
                    }
                } else {
                    if(reelId < 2 && symId === 0) {
                        return;
                    }
                }

                result.push([symbol]);
            });
        });
        // Logger.logDev(`FruitsServerDataParser.parsedReels = ${result.toString()}`);
        return result;
    }

    // this feature will not be trigger in bonus game mode.
    public parseOverlayStickySymbols(input:boolean[][]):boolean[] {
        let result:boolean[] = [];
        input.forEach((reel:boolean[], reelId:number) => {
            if(reelId < 2) {
                result = result.concat(reel.slice(1))
            } else {
                result = result.concat(reel);
            }
        });
        return result;
    }

    private flattenRandomOverlayPositions(input:boolean[][]):boolean[] {
        let result:boolean[] = [];
        input.forEach((reel:boolean[], reelId:number) => {
            if(reelId < 2) {
                result = result.concat(reel.slice(1))
            } else {
                result = result.concat(reel);
            }
        });
        return result;
    }

    public parseRandomOverlayPositions(symbolOverlayPositions:boolean[][]):number[] {
        const flatten = this.flattenRandomOverlayPositions(symbolOverlayPositions);
        const sorted:number[] = [];

        for (let i:number = 0; i < flatten.length; i++) {
            if(flatten[i]) {
                sorted.push(i);
            }
        }

        return sorted;
    }

    public parseStickySymbol(rawData:IFruitsServerData):string {
        return rawData.stickySymbol;
    }

    public parseBonusSpinsLeft(rawData:IFruitsServerData):number {
        return rawData.numberOfBonusSpinsRemaining;
    }

    public parseBonusSpinsPlayed(rawData:IFruitsServerData):number {
        return rawData.numberOfBonusSpinsPlayed;
    }

    public parseNumberOfBonusSpinsPlayed(rawData:IFruitsServerData):number {
        return rawData.numberOfBonusSpinsPlayed;
    }

    public parseIsBonusTriggeredThisSpin(rawData:IFruitsServerData):boolean {
        return rawData.isBonusTriggeredThisSpin;
    }

    public parseBonusGameQueued(rawData:IFruitsServerData):boolean {
        return rawData.bonusGameQueued;
    }

    public parseIsStickyRespinTriggeredThisSpin(rawData:IFruitsServerData):boolean {
        return rawData.isStickyRespinTriggeredThisSpin;
    }

    public parseSymbolOverlayPositions(rawData:IFruitsServerData):boolean[][] {
        return rawData.symbolOverlayPositions;
    }

    public parseRandomSymbolOverlayTriggered(rawData:IFruitsServerData):boolean {
        return rawData.randomSymbolOverlayTriggered;
    }

    public parseRandomOverlaySymbol(rawData:IFruitsServerData):string {
        return rawData.randomOverlaySymbol;
    }

    public parseNumberOfOverlaySymbols(rawData:IFruitsServerData):number {
        return rawData.numberOfOverlaySymbols;
    }

    public parseBonusOverlayPositionsBefore(rawData:IFruitsServerData):boolean[][] {
        return rawData.bonusOverlayPositionsBefore;
    }

    public parseBonusOverlayPositionsAfter(rawData:IFruitsServerData):boolean[][] {
        return rawData.bonusOverlayPositionsAfter;
    }

    public parseNewBonusOverlayPositions(rawData:IFruitsServerData):boolean[][] {
        return rawData.newBonusOverlayPositions;
    }

    public parseCurrentBonusPaytable(rawData:IFruitsServerData):number[] {
        return rawData.currentBonusPaytable;
    }

    public parseBonusPaytableBeforeSpin(rawData:IFruitsServerData):number[] {
        return rawData.bonusPayTableBeforeSpin;
    }

    public parseBonusPaytableAfterSpin(rawData:IFruitsServerData):number[] {
        return rawData.bonusPayTableAfterSpin;
    }

    public parseCollectedScatterBefore(rawData:IFruitsServerData):number {
        return rawData.collectedScatterBefore;
    }

    public parseCollectedScatterAfter(rawData:IFruitsServerData):number {
        return rawData.collectedScatterAfter;
    }

    public parseNumberOfUpgradesBefore(rawData:IFruitsServerData):number {
        return rawData.numberOfUpgradesBefore;
    }

    public parseNumberOfUpgradesAfter(rawData:IFruitsServerData):number {
        return rawData.numberOfUpgradesAfter;
    }

    public parseNumberOfUpgradesThisSpin(rawData:IFruitsServerData):number {
        return rawData.numberOfUpgradesThisSpin;
    }

    public parseFinalBonusWin(rawData:IFruitsServerData):number {
        return rawData.finalBonusWin;
    }

    public parseReelsEnteringBonus(rawData:IFruitsServerData):string[][] {
        return rawData.reelsEnteringBonus;
    }

    public parseUpgradeTriggered(rawData:IFruitsServerData):boolean {
        return rawData.upgradeTriggered;
    }

    public parseBonusSpecialSymbolMultiplier(rawData:IFruitsServerData):boolean[][] {
        return rawData.bonusSpecialSymbolMultiplier;
    }

    public parseBonusSpecialSymbolExtraSpin(rawData:IFruitsServerData):boolean[][] {
        return rawData.bonusSpecialSymbolExtraSpin;
    }

    public parseNearWinPositions(rawData:IFruitsServerData):boolean[][] {
        return rawData.nearWinPositions;
    }


    public parseBigWinExcitementPositions(rawData:IFruitsServerData):boolean[][] {
        return rawData.bigWinExcitementPositions;
    }

    public parseNumberOfSpinsRemaining(rawData:IFruitsServerData){
        return rawData.numberOfSpinsRemaining;
    }

    public parseIsExcitementSpinTriggered(rawData:IFruitsServerData) {
        return rawData.isExcitementSpinTriggered;
    }

    public parseBonusInitReels(rawData:IFruitsInitData):string[][] {
        return rawData.bonusInitReels;
    }

    public parseBigWinExcitementPositionsPortrait(rawData:IFruitsServerData):boolean[][] {
        return rawData.bigWinExcitementPositionsPortrait;
    }

    public parseNearWinPositionsPortrait(rawData:IFruitsServerData):boolean[][] {
        return rawData.nearWinPositionsPortrait;
    }

    public parseOverlaySymbolsBeforeSpin(rawData:IFruitsServerData):string[][] {
        return rawData.parseOverlaySymbolsBeforeSpin;
    }

    public parseOverlaySymbolsAfterSpin(rawData:IFruitsServerData):string[][] {
        return rawData.parseOverlaySymbolsAfterSpin;
    }

    public parseIsExcitementSpinTriggeredPortrait(rawData:IFruitsServerData) {
        return rawData.isExcitementSpinTriggeredPortrait;
    }

    // TODO: scatter positions
    // TODO: nearWinPositions/nearWinReels
    // TODO: winPositions



}